
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.291 3.853c1.564.137 2.732 1.52 2.597 3.073l-2.295 26.23c-.136 1.553-1.527 2.712-3.09 2.575L3.537 32.147C1.974 32.01.806 30.627.942 29.074l2.295-26.23C3.372 1.291 4.763.132 6.327.27l40.964 3.584zm-6.566 19.94a3.643 3.643 0 00-2.051.42 3.641 3.641 0 00-1.946-.77c-2.005-.176-3.772 1.297-3.946 3.289-.175 1.992 1.31 3.75 3.315 3.925a3.647 3.647 0 002.05-.421c.54.426 1.208.706 1.947.77 2.005.176 3.771-1.297 3.945-3.29.175-1.99-1.31-3.748-3.314-3.924zm-14.701 2.87L6.216 24.93l-.267 3.054 19.807 1.733.268-3.054zm-6.54-6.208L6.706 19.337l-.267 3.054 12.778 1.118.267-3.054z","fill":"currentColor"}})])
          )
        }
      }
    